export default {
  home: {
    minute: "دقيقة",
    hour: "ساعة",
    day: "يوم",
    price_info:
      "الدقائق {mianfei} الأولى مجانية. الحد الأقصى للإcharge خلال 24 ساعة هو {currencyName}{fengding}. سيتم إرجاع وديعة {currencyName}{yajin} الخاصة بك تلقائيًا بعد إرجاع البنك الكهربائي",
    feature_1: "يتضمن جميع أنواع الكابلات: iPhone وType-C وMicro-USB",
    feature_2: "يمكن إرجاعه في أي محطة",
    feature_3: "الشحن اللاسلكي متاح",
    tips_1: "سيتم إرجاع وديعة {currencyName}{yajin} الخاصة بك في نهاية الإيجار",
    tips_2: "يمكن استخدام وديعة {currencyName}{yajin} للإيجار، وعند استخدامها يمكن استردادها",
    tips_3: "الرصيد الحالي هو {currencyName}{myyue}، ويمكن استخدامه للإيجار مباشرة",
    submit: "بدء الإيجار",
    borrow: "استعارة",
    msg_fail_title: "خطأ",
    msg_fail_content: "فشل الإيجار، يرجى المحاولة مرة أخرى",
    msg_rentcount: "لديك حاليًا {zujieNum} طلبات غير مغلقة",
    goborrow: "اذهب للشحن!!!",
    nearby: "عرض المحطات القريبة",
    preauth: "التفويض المسبق",
    mine: "حسابي",
    help: "مساعدة",
    searchstation: "الفروع القريبة"
  },
  login: {
    email: "البريد الإلكتروني",
    code_title: "التحقق بالرسائل القصيرة",
    phone_number: "رقم الهاتف",
    verification_phone: "يرجى إدخال رقم الهاتف الخاص بك",
    verification_email: "يرجى إدخال عنوان البريد الإلكتروني الخاص بك",
    verification_code: "يرجى إدخال رمز التحقق من الرسائل القصيرة",
    verification_emailcode: "يرجى إدخال رمز التحقق من البريد الإلكتروني",
    verification_captcha_code: "يرجى إدخال رمز التحقق من الصورة",
    captcha_code: "الرمز",
    send_code: "إرسال الرمز",
    login: "تسجيل الدخول",
    agree: "بالنقر على تسجيل الدخول، أنت توافق على ",
    readme: "اتفاقية المستخدم",
    msg_fail_login: "فشل تسجيل الدخول",
    msg_success_login: "تم تسجيل الدخول بنجاح",
    msg_fail_user: "خطأ في الحصول على معلومات المستخدم. هل تريد المحاولة مرة أخرى؟",
    sign_in_with: "تسجيل الدخول باستخدام",
    no_sms: "لم تستلم الرسالة النصية",
    retry: "إعادة الإرسال"
  },
  confirm: {
    deletecard: "حذف البطاقة",
    addcard: "إدخال تفاصيل البطاقة",
    title: "تأكيد الدفع",
    paynow: "الدفع الفوري",
    SMSConfirm: "يرجى الدفع وفقًا للرسالة النصية المستلمة على هاتفك والنقر على زر التأكيد للمتابعة.",
    pay_label: "المبلغ",
    auth_label: "التفويض المسبق",
    price_tips: "يمكن سحب رصيدك عند الطلب. قد يستغرق الأمر 1-5 أيام عمل ليظهر في حساب الدفع الخاص بك.",
    auth_tips: "مبلغ التفويض المسبق {0}{1} إلزامي. سيتم خصم مبلغ الإيجار الفعلي عند إرجاع البنك الكهربائي.",
    pay_type: "يرجى اختيار طريقة الدفع المفضلة لديك",
    submit: "تأكيد الدفع",
    msg_loading: "جاري التحميل...",
    msg_fail_title: "تحذير",
    msg_fail_payment: "فشل بدء دفع الوديعة",
    msg_fail_order: "فشل إنشاء طلب الإيجار",
    msg_fail_support: "النظام غير مدعوم",
    msg_fail_confirm: "تأكيد",
    msg_fail_retry: "إعادة المحاولة",
    msg_fail_cancel: "إلغاء"
  },
  mine: {
    title: "ملف المستخدم",
    wallet: "محفظتي",
    balance: "رصيدي",
    deposit: "الوديعة",
    wallet_in: "شحن",
    wallet_out: "سحب",
    wallet_log: "سجل المحفظة",
    order: "الطلب",
    coupon: "القسيمة",
    login_tips: "يرجى تسجيل الدخول",
    msg_fail_title: "خطأ",
    msg_fail_update: "فشل التعديل. يرجى المحاولة مرة أخرى",
    msg_loading: "جاري التحميل...",
    msg_fail_user: "خطأ في الحصول على معلومات المستخدم. هل تريد المحاولة مرة أخرى؟",
    help: "مساعدة",
    setting: "الإعدادات",
    logout: "تسجيل الخروج",
    buy: "شراء المعدات"
  },
  msg: {
    appoffline: "التطبيق لم يتم إطلاقه بعد، يرجى الانتظار",
    deletecard: "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
    no_phone: "رقم الهاتف مطلوب",
    loading: "جاري التحميل...",
    title: "تلميح",
    success: "تمت العملية بنجاح",
    error: "خطأ غير معروف. يرجى المحاولة مرة أخرى لاحقًا",
    roleerror: "صلاحيات غير كافية. يرجى استشارة المسؤول.",
    neterror: "فشل الاتصال بالشبكة. يرجى المحاولة مرة أخرى لاحقًا",
    confirm: "تأكيد",
    retry: "إعادة المحاولة",
    cancel: "إلغاء",
    title_fail: "تحذير",
    vieworder: "عرض الطلب",
    success_payment: "تم الدفع بنجاح",
    success_buy: "تم الشراء بنجاح",
    fail_payment: "فشل الدفع",
    keyword: "كلمة مفتاحية",
    ispayorder: "يرجى تأكيد ما إذا كان الدفع قد تم",
    unpay: "غير مدفوع",
    yespay: "مدفوع",
    notopen: "غير مفتوح بعد"
  },
  result: {
    tips: "لعرض الطلبات ومواقع المحطات الأخرى، يرجى تنزيل التطبيق.",
    download: "تنزيل",
    title: "تم تأكيد الإيجار",
    gotit: "فهمت",
    price_plan: "معايير الشحن",
    msg_success: "تم الاستعارة بنجاح",
    msg_tips_loading: "جارٍ إخراج البنك الكهربائي، يرجى الانتظار..",
    msg_result_loading: "جارٍ تأكيد نتيجة الدفع...",
    msg_fail_confirm: "تأكيد",
    btn_usage: "ملاحظة الاستخدام",
    btn_return: "ملاحظة الإرجاع",
    deposit: "الوديعة",
    msg_fail_content: "فشل الطلب. يرجى المحاولة مرة أخرى.",
    price_label: "لكل ساعة",
    price_info: "مجاني للدقائق {mianfei} الأولى، الحد الأقصى للشحن اليومي {ccurrency}{fengding}. سيتم خصم الوديعة تلقائيًا عندما يصل الإيجار إلى {ccurrency}{yajin}",
    tips_1: "يرجى جمع البنك الكهربائي رقم {number} كما هو موضح في الصورة",
    tips_2: "يرجى تنظيم الكابلات وإدخال البنك الكهربائي في الفتحة بالجانب المشار إليه بأسهم لأسفل",
    msg_note_usage: "البنك الكهربائي مزود بـ 3 أنواع من الكابلات، يرجى اختيار الكابل المناسب لجهازك.",
    msg_note_return: "يرجى تنظيم الكابلات وإدخال البنك الكهربائي في الفتحة بالجانب المشار إليه بأسهم لأسفل",
    return_info: "عند الإرجاع، تأكد من تنظيم الكابلات وإدخال الجانب ذو الرقائق المعدنية في مقبس متاح حتى يصل إلى القاع ويستقر."
  },
  result_msg: {
    loading: "جاري التحميل...",
    refresh: "تحديث"
  },
  order: {
    title: "طلب الإيجار",
    in_use: "قيد الاستخدام",
    ended: "منتهي",
    msg_error: "فشل الطلب"
  },
  order_item: {
    order_number: "رقم.",
    venue_rented: "مكان الاستلام",
    time_rented: "وقت الاستلام",
    venue_returned: "مكان الإرجاع",
    time_returned: "وقت الإرجاع",
    charge_standard: "معايير الشحن",
    charge_standard_info: "{pJifei} {pCurrency} لكل ساعة (أول {pMian} دقيقة مجانية)",
    rent_occurred: "حدث الإيجار",
    returned: "تم الإرجاع",
    unreturned: "غير مُرجع",
    type_0: "غير مكتمل",
    type_1: "قيد الإيجار",
    type_2: "ملغى",
    type_3: "تم الإرجاع",
    type_4: "حدث خطأ",
    type_5: "متأخر",
    min: "دقيقة",
    payment: "الدفع"
  },
  setting: {
    title: "الإعدادات",
    lang: "اللغة"
  },
  help: {
    title: "الأسئلة الشائعة"
  },
  wallet_in: {
    title: "شحن الرصيد",
    price_label: "مبلغ الشحن",
    price_placeholder: "يرجى إدخال مبلغ الشحن",
    balance: "الرصيد الحالي",
    price_auto: "اختر مبلغ الدفع",
    price_tips: "يمكن سحب رصيدك عند الطلب. قد يستغرق الأمر 1-5 أيام عمل ليظهر في حساب الدفع الخاص بك.",
    submit: "إرسال",
    loading: "جاري التحميل...",
    paying: "جارٍ التحويل إلى صفحة الدفع..",
    msg_title: "تلميحات",
    msg_fail_order: "فشل إنشاء طلب الشحن",
    msg_fail_payment: "فشل بدء دفع الشحن",
    msg_fail_retry: "إعادة المحاولة"
  },
  wallet_out: {
    title: "السحب",
    price_label: "مبلغ السحب",
    price_placeholder: "يرجى إدخال مبلغ السحب",
    balance: "الرصيد الحالي",
    balance_all: "سحب الكل",
    deposit: "الوديعة",
    deposit_tips: "هناك طلب إيجار قائم. الوديعة {pyajin} غير قابلة للاسترداد",
    submit: "إرسال",
    apply: "تطبيق",
    confirm: "تأكيد",
    loading: "جاري التحميل...",
    msg_fail_price: "مبلغ السحب غير صحيح",
    msg_fail_balance: "لا يمكن أن يتجاوز مبلغ السحب الرصيد الحالي",
    msg_fail_submit: "يرجى ملء جميع المعلومات المطلوبة",
    msg_title: "خطأ",
    msg_success_content: "تم الاسترداد بنجاح",
    confirmtitle: "تلميحات",
    confirmcontent: "المحفظة الحالية لا تدعم السحب النقدي. يرجى تسجيل معلومات الاتصال الخاصة بك لمعالجة الاسترداد يدويًا",
    payee_name: "اسم المستفيد",
    payee_bankcard: "رقم البطاقة المصرفية",
    payee_phone: "الهاتف",
    cancelText: "إلغاء",
    confirmText: "إعادة التقديم"
  },
  map: {
    在线: "متصل",
    离线: "غير متصل",
    title: "المحطة القريبة",
    result_msg: "لم يتم العثور على محطة قريبة",
    msg_title: "خطأ",
    no_support: "عذرًا! متصفحك لا يدعم خدمات الموقع",
    my_position: "موقعي",
    distance: "المسافة:",
    shop_time: "ساعات",
    free: "متاح للإيجار",
    return: "مواقع فارغة متاحة",
    shop_title: "تفاصيل المكان",
    address: "العنوان",
    go_here: "اذهب هنا"
  }
};
